// Shared formatting for measurement results — used by both the finished
// per-entity Properties panel (MeasurementDetailPanel) and the live
// in-progress labels drawn while a shape is still being sketched
// (MeasureToolbar/drawOverlays.ts). One implementation, not two copies.
export function formatLength(meters: number): string {
  return meters > 1000 ? `${(meters / 1000).toFixed(3)} km` : `${meters.toFixed(2)} m`;
}

export function formatArea(sqMeters: number): string {
  return sqMeters > 1_000_000 ? `${(sqMeters / 1_000_000).toFixed(3)} km²` : `${sqMeters.toFixed(2)} m²`;
}
